import Styles from './Drawer.module.scss'
import { PropsWithChildren } from 'react'
import { WithClassName, WithColor, WithFullHeight, WithShadow, WithSnappedTop } from 'components/Drawer/Types'
import cx from 'classnames'

export const InnerContent = ({
  children,
  fullHeight = false,
  isSnappedTop = false,
  withShadow = false,
  color,
  className,
  ...props
}: PropsWithChildren<WithFullHeight & WithSnappedTop & WithShadow & WithColor & WithClassName>) => (
  <div
    {...props}
    className={cx(Styles.innerContent, className, {
      [Styles.fullHeight]: fullHeight,
      [Styles.snappedTop]: isSnappedTop,
      [Styles.withShadow]: withShadow,
    })}
    style={{ backgroundColor: color }}
  >
    {children}
  </div>
)
